<script setup lang="ts">
  import { ConnectionStatus } from './types';

  const { status = 'warning' } = defineProps<{ status: ConnectionStatus }>();
</script>

<template>
  <div class="connection">
    <slot />
    <span :class="['connection__dot', `connection__dot--${status}`]"/>
  </div>
</template>

<style scoped>
  .connection {
    width: fit-content;
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .connection__dot {
    height: 4px;
    width: 4px;
    border-radius: 100%;
    display: inline-block;
  }

  .connection__dot--success {
    background-color: var(--sf-base-icon-success);
  }

  .connection__dot--neutral {
    background-color: var(--sf-base-icon-tertiary);
  }

  .connection__dot--warning {
    background-color: var(--sf-base-icon-warning);
  }
  
  .connection__dot--error {
    background-color: var(--sf-base-icon-error);
  }
</style>
